import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLanguage } from '@/contexts/LanguageContext';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import AboutSection from '@/components/AboutSection';
import FacilitiesSection from '@/components/FacilitiesSection';
import ListingsSection from '@/components/ListingsSection';
import GallerySection from '@/components/GallerySection';
import TestimonialsSection from '@/components/TestimonialsSection';
import LocationSection from '@/components/LocationSection';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';

const API = process.env.REACT_APP_BACKEND_URL;

export default function HomePage() {
  const [spaces, setSpaces] = useState([]);
  const { dir } = useLanguage();

  useEffect(() => {
    axios.get(`${API}/api/spaces`).then(res => setSpaces(res.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#0B1120]" dir={dir}>
      <Navbar />
      <HeroSection />
      <AboutSection />
      <FacilitiesSection />
      <ListingsSection spaces={spaces} />
      <GallerySection />
      <TestimonialsSection />
      <LocationSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
